import { Fragment } from 'react';
import type { AnswerToken } from '@/entities/chat';
import ChatQuestionBubble from '@/entities/chat/ui/ChatQuestionBubble';
import { sanitizeChatHtml } from '@/shared/lib/sanitizeChatHtml';

const DemoChatQuestion = ({ question }: { question: AnswerToken[] }) => {
  return (
    <ChatQuestionBubble
      containerClassName="max-w-[70%]"
      bubbleClassName="flex shrink flex-wrap rounded-md border border-primary bg-primary px-[10px] py-[10px] text-justify text-label1 font-[400] text-white main:px-[20px] main:text-body2 main:font-[500] wrap-break-word break-keep"
    >
      {question.map((q, i) => {
        if (
          q.text.trim() === '<br />' ||
          q.text.trim() === '<br/>' ||
          q.text.trim() === '<br>'
        ) {
          return <br key={i} />;
        }
        if (q.text.trim() === '&nbsp;' || !q.text.trim()) {
          return <Fragment key={i} />;
        }

        return (
          <span
            key={i}
            className="animate-fade-in transition-all"
            dangerouslySetInnerHTML={{
              __html: sanitizeChatHtml(
                q.text === '<br /> ' ? '<br />' : q.text
              ),
            }}
          ></span>
        );
      })}
    </ChatQuestionBubble>
  );
};

export default DemoChatQuestion;
